import styled from 'styled-components';
import { neutral, primary } from '../../../style/colors';

export const ExpandIcon = styled.i`
  font-size: 20px;
  color: ${neutral[500]};
  transition: transform 0.2s ease, color 0.2s ease;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  pointer-events: none;
`;

export const ExpandButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  transition: background 0.2s ease;
  cursor: pointer;
  
  &:hover {
    background: ${neutral[100]};
    
    ${ExpandIcon} {
      color: ${primary[500]};
    }
  }
`;

export const DepartmentName = styled.span`
  font-size: 13px;
  color: ${neutral[600]};
  font-weight: 500;
`;

